import React from "react";

export default function NavbarBrand({
  isDemo,
  logoApp,
  logoMairie,
  ville,
  brandBg,
  brandText,
  onClick,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group min-w-0 flex-1 cursor-pointer select-none text-left"
      aria-label="Retour à l’accueil"
    >
      {isDemo ? (
        <div className="flex min-w-0 items-center gap-4">
          <div className="relative shrink-0">
            <div className="absolute -inset-2 rounded-[1.5rem] bg-sky-500/15 opacity-0 blur-xl transition group-hover:opacity-100" />
            <img
              src={logoApp}
              alt="MonAppliMairie"
              className="relative hidden h-16 w-auto object-contain sm:block md:h-[74px] bg-white/80 rounded-2xl p-1 ring-1 ring-white/10"
            />

            <div
              className="relative flex h-12 w-12 items-center justify-center rounded-2xl text-base font-bold sm:hidden"
              style={{ ...brandBg, ...brandText }}
            >
              M
            </div>
          </div>

          <div className="min-w-0">
            <p className="truncate text-lg font-bold leading-tight text-white md:text-xl">
              MonAppliMairie
            </p>

            <p className="mt-1 hidden max-w-[300px] text-xs font-semibold leading-tight text-slate-300 lg:block xl:max-w-[380px]">
              <span className="block truncate">
                Démonstration d’un site internet municipal
              </span>
              <span className="block truncate text-slate-400">
                moderne, responsive et administrable
              </span>
            </p>
          </div>
        </div>
      ) : (
        <div className="flex min-w-0 items-center gap-4">
          <div className="relative shrink-0">
            <div className="absolute -inset-2 rounded-[1.5rem] bg-white/10 opacity-0 blur-xl transition group-hover:opacity-100" />

            {logoMairie ? (
              <img
                src={logoMairie}
                alt={ville}
                className="relative h-14 w-14 rounded-2xl object-cover ring-1 ring-white/10 md:h-20 md:w-20"
              />
            ) : (
              <div
                className="relative flex h-12 w-12 items-center justify-center rounded-2xl text-lg font-bold md:h-16 md:w-16"
                style={{ ...brandBg, ...brandText }}
              >
                {ville?.charAt(0) || "M"}
              </div>
            )}
          </div>

          <div className="min-w-0">
            <p className="truncate text-lg font-bold uppercase leading-tight text-white md:text-xl">
              {ville || "Votre mairie"}
            </p>

            <p className="mt-1 hidden text-xs font-semibold leading-tight text-slate-300 lg:block">
              <span className="block">Site officiel de la commune</span>
              <span className="block text-slate-400">
                Informations, services et démarches
              </span>
            </p>
          </div>
        </div>
      )}
    </button>
  );
}